// wegogolf-app/src/components/ManagerPermission/ContactActions.js
import React, { memo } from 'react';
import { SquarePen, Trash2 } from 'lucide-react';
import { withRole } from '../Common/withRole';
import { SmallButton, DangerButton, PrimaryButton, DefaultButton } from '../Common/BaseButton';

// Base component for editing existing contacts
const ContactActionsContent = memo(({ contact, onEdit, onDelete }) => (
  <div style={{ display: 'flex', gap: '0.5rem', marginLeft: 'auto', marginTop: '0.5rem' }}>
    <SmallButton onClick={() => onEdit(contact)}>
      <SquarePen size={16} />
    </SmallButton>
    <DangerButton onClick={() => onDelete(contact.id)}>
      <Trash2 size={16} />
    </DangerButton>
  </div>
));

// Base component for saving/canceling edits
const EditableContactActionsContent = memo(({ onCancel, onSave }) => (
  <div style={{ display: 'flex', gap: '0.5rem', marginLeft: 'auto', marginTop: '0.5rem' }}>
    <DefaultButton onClick={onCancel} style={{ minWidth: 70 }}>
      Cancel
    </DefaultButton>
    <PrimaryButton onClick={onSave} style={{ minWidth: 70 }}>
      Save
    </PrimaryButton>
  </div>
));

// Create the role-wrapped components
const WithRoleContactActions = withRole(ContactActionsContent, { managerOnly: true });
const WithRoleEditableContactActions = withRole(EditableContactActionsContent, { managerOnly: true });

// Create the final components
export const ManagerOnlyContactActions = memo(({ contact, onEdit, onDelete, isManager, isAuthenticated }) => {
  return (
    <WithRoleContactActions 
      isManager={isManager}
      isAuthenticated={isAuthenticated}
      contact={contact}
      onEdit={onEdit}
      onDelete={onDelete}
    />
  );
});

export const ManagerOnlyEditableContactActions = memo(({ onCancel, onSave, isManager, isAuthenticated }) => {
  return (
    <WithRoleEditableContactActions 
      isManager={isManager}
      isAuthenticated={isAuthenticated}
      onCancel={onCancel}
      onSave={onSave}
    />
  );
});